<script>
import appConfig from '@src/app.config'
import { mapGetters, mapState } from 'vuex'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  computed: {
    ...mapGetters('common', ['is_inited']),
    ...mapState('common', ['locale']),
  },
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView v-if="is_inited" :key="`${$route.fullPath}|${locale}`" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';
@import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');
body {
  background: $color-body-bg;
}

#nprogress .bar {
  background: $color-link-text;
}
</style>
